<template>
  <div>
    <school-recipient :model="schema.recipient" class="mt-2" />

    <w-input :model="schema.schoolYear" class="mt-2" />
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import SchoolRecipient from './components/SchoolRecipient';

// @vuese
// Formularz pisma informacyjnego z listą uczniów
// @group ActionData
export default {
  components: { ...components, SchoolRecipient },
  props: {
    // schema
    schema: { type: Object, required: true },
    // Dokumenty
    documents: { type: Array, required: true }
  },
  watch: {
    documents() {
      this.setRecipient();
    }
  },
  mounted() {
    this.setRecipient();
  },
  methods: {
    // @vuese
    // Ustawia dane odbiorcy na podstawie pierwszej szkoły na liście
    setRecipient() {
      const documentWithSchool = this.documents.find(document => !!document.data.school);
      if (documentWithSchool) {
        documentWithSchool.data.directorName = '';

        this.schema.recipient.$setData(documentWithSchool.data);
      }
    }
  }
};
</script>
